/* eslint-disable */ 
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import propTypes from 'prop-types'
import "../../styles/NavItems/NavItem.css"
const NavItem = ({ state, title, path, icon, activeFont = "#6F944E", activeBackground = "#ECFFDB", style }) => {
    return (
        <li className='navItems' style={{ "--activeLinkColor": activeFont, "--activeLinkBackground": activeBackground, ...style }}>
            <NavLink className={({ isActive }) => {
                return isActive ? "activeLink" : "inActiveLink"
            }} to={path} state={state}>
                {icon}
                <span>{title}</span>
            </NavLink></li >
    )
}





NavItem.propType = {
    title: propTypes.string.isRequired,
    path: propTypes.string.isRequired,
    icon: propTypes.element.isRequired,
    activeFont: propTypes.string,
    activeBackground: propTypes.string,
}

export default NavItem

